// extracted by mini-css-extract-plugin
module.exports = {"emptySearch":"EmptySearchResults_emptySearch__pQ84q","headerMessage":"EmptySearchResults_headerMessage__jTvak","footerMessage":"EmptySearchResults_footerMessage__0uuul"};